/**
 * Module-level pub/sub for app-wide toasts. The single ToastProvider registers the emitter; both
 * useToast() and non-React callers (e.g. Http.js via emitGlobalToast) route through here. Toasts
 * sent before an emitter is registered are queued and shown once it registers.
 */

let emitter = null;
let pending = [];

export const setShowToastEmitter = (fn) => {
  emitter = typeof fn === "function" ? fn : null;
  if (emitter && pending.length) {
    const queued = pending;
    pending = [];
    queued.forEach((args) => emitter(...args));
  }
};

export const clearShowToastEmitter = () => {
  emitter = null;
};

// Full-signature dispatch for useToast(); `container` is accepted for compatibility but not forwarded.
export const dispatchToast = (
  message,
  alertType = "error",
  _container = null,
  toastDuration = 6000,
  action = null
) => {
  if (!message) return;
  if (emitter) emitter(message, alertType, toastDuration, action);
  else pending.push([message, alertType, toastDuration, action]);
};

export const emitGlobalToast = (
  message,
  type = "error",
  duration = 6000
) => {
  dispatchToast(message, type, null, duration, null);
};
